import {
  type FC,
} from 'react';
import {
  useDispatch
} from 'react-redux';
import {
  Badge,
  IconButton,
  useTheme,
} from '@mui/joy';
import {
  BellIcon
} from '../assets';
import {
  useMessagesSelector,
  selectIsAnyUnreadMessage,
  openNotificationsSidebar,
} from '../model';

export type NotificationsSidebarToggleProps = {
  onClick?(): void;
};

export const NotificationsSidebarToggle: FC<NotificationsSidebarToggleProps> = ({ onClick }) => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const isAnyUnreadMessage = useMessagesSelector(selectIsAnyUnreadMessage);

  const handleClick = (): void => {
    dispatch(openNotificationsSidebar());
    onClick?.();
  };

  return (
    <Badge
      size='sm'
      badgeInset='33%'
      badgeContent={isAnyUnreadMessage ? <></> : null}
      color='danger'
      sx={{
        '.MuiBadge-badge': {
          minWidth: 7,
          minHeight: 7,
          padding: 0,
          boxShadow: `0 0 0 1px ${theme.palette.common[475]}`,
        },
      }}>
      <IconButton
        size='sm'
        onClick={handleClick}
        sx={{
          width: 36,
          height: 36,
          position: 'relative',
          overflow: 'hidden',
          // TODO: Replace with theme palette colors in the future
          backgroundColor: '#252C37',
          '&:hover': { backgroundColor: '#434A55' },
        }}>
        <BellIcon style={{ width: 24, height: 24 }} />
      </IconButton>
    </Badge>
  );
};
